import React, { useEffect, useState } from 'react'
import { fundTransfer, getAccountDetails } from '../../../api/CommonRequest';

function PaymentTransfer({ transferData, handleCancel,setChange }) {

    const [contactDetails, setContactDetails] = useState();
    const [selectedAccount, setSelectedAccount] = useState();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [transfer, setTransfer] = useState(false);

    const [errors, setErrors] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const details = {
                amount: transferData.amount,
                type: transferData.type,
                account_id: selectedAccount?.fundAccountId,
                bankAccountId: selectedAccount?._id,
                id: transferData._id
            }
            const { data } = await fundTransfer(details)
            if (data.success) {
                setTransfer(true)
                setMessage('Transfer initiated successfully!');

            }
            console.log(data);
        } catch (error) {
            setMessage('Transfer failed: ' + error.response?.data?.message || error.message);
            setLoading(false);
        }


    }




    useEffect(() => {
        setSelectedAccount(transferData?.to?.roleDetails?.bankDetailsIDs[0])
        setContactDetails(transferData?.to)
    }, []);

    const OnhandleCancel = () => {
        handleCancel()
    }
    const handleClose = () => {
        handleCancel()
        setChange(Date.now())
    }

    return (
        <div>
            <div className="space-y-4">
                {message && (
                    <div className="mb-4 p-3 bg-blue-100 text-blue-900 rounded">
                        {message}
                    </div>
                )}
                <div className="p-4 bg-gray-50 rounded">
                    <h3 className="font-medium mb-3">Transfer Details</h3>
                    <div className="space-y-2">
                        <div className="flex justify-between">
                            <span>Amount:</span>
                            <span>₹{transferData.amount}</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Type:</span>
                            <span>{transferData.type}</span>
                        </div>
                        <div className="flex justify-between font-bold">
                            <span>Total Amount:</span>
                            <span>₹{transferData.amount}</span>
                        </div>
                    </div>
                </div>

                {/* <div className="p-4 bg-gray-50 rounded">

                    <h3 className="font-medium mb-3">Contact Details</h3>
                    <div>
                        <p>Name: {contactDetails?.name}</p>
                        <p>Role: {contactDetails?.role}</p>
                        <p>Phone : {contactDetails?.phone}</p>
                    </div>
                </div>
                <div className="p-4 bg-gray-50 rounded">

                    <h3 className="font-medium mb-3">Account Details</h3>
                    <div>
                        <p>Bank: {selectedAccount?.bankName}</p>
                        <p>Branch: {selectedAccount?.branchName}</p>
                        <p>Account Holder: {selectedAccount?.accountHolderName}</p>
                        <p>Account Number: {selectedAccount?.accountNumber}</p>
                        <p>IFSC: {selectedAccount?.ifscCode}</p>
                    </div>
                </div> */}
                <div className="p-4 bg-gray-50 rounded flex justify-between">
                    <div>
                        <h3 className="font-medium mb-3">Contact Details</h3>
                        <div>
                            <p>Name: {contactDetails?.name}</p>
                            <p>Role: {contactDetails?.role}</p>
                            <p>Phone : {contactDetails?.phone}</p>
                        </div>
                    </div>
                    <div>

                        <h3 className="font-medium mb-3">Account Details</h3>
                        <div>
                            <p>Bank: {selectedAccount?.bankName}</p>
                            <p>Branch: {selectedAccount?.branchName}</p>
                            <p>Account Holder: {selectedAccount?.accountHolderName}</p>
                            <p>Account Number: {selectedAccount?.accountNumber}</p>
                            <p>IFSC: {selectedAccount?.ifscCode}</p>
                        </div>
                    </div>

                </div>
                {transfer ?
                    <div className='flex justify-center mt-6'>

                        <button
                            // type="submit"
                            onClick={handleClose}
                            // disabled={loading}
                            className=" px-4  py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
                        >
                            Close
                        </button>
                    </div>
                    :
                    <div className='flex justify-between '>
                        <button
                            type="button"
                            onClick={OnhandleCancel}
                            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
                        >
                            cancel
                        </button>
                        <button
                            type="submit"
                            onClick={handleSubmit}
                            disabled={loading}
                            className="ml-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
                        >
                            {loading ? 'Processing...' : 'Confirm Transfer'}
                        </button>
                    </div>
                }
            </div>
        </div>
    )
}

export default PaymentTransfer